export enum DisplayStatuses {
  complete = 'Complete',
  incomplete = 'Incomplete',
  pending = 'Pending',
  processing = 'Processing',
  new = 'New'
}